<template>
    <g>
        <path d="M18.75 4.375L15.625 1.25L3.125 13.75L1.875 18.125L6.25 16.875L18.75 4.375ZM13.125 3.75L16.25 6.875L13.125 3.75ZM3.125 13.75L6.25 16.875L3.125 13.75Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
</template>